module.exports = __webpack_public_path__ + "img/icon_small_down_arrow.6bbe9b99.svg";